import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalSearchResponse } from '@data/schema/global-search-response';
import { environment } from '@environments/environment';
import { ApiPaths } from '@gah-core/constants/api-paths.enum';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GlobalSearchService {
  private searchSubject = new BehaviorSubject('');

  constructor(private http: HttpClient) {}

  setSearchValue(search: string) {
    this.searchSubject.next(search);
  }
  getSearchValue(): Observable<string> {
    return this.searchSubject.asObservable();
  }
  getSearchResults(query: Observable<any>) {
    return query.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((search) => {
        if (search && search.searchKeyword.trim().length > 0) {
          return this.fetchSearchResults(search);
        } else {
          return of([]);
        }
      })
    );
  }

  fetchSearchResults(reqData): Observable<GlobalSearchResponse> | null {
    return this.http.post<any>(`${environment.apiUrl}${ApiPaths.GlobalSearch}`, reqData);
  }
}
